import React, { useMemo } from 'react';

export default function AliasFilterDropdown({
                                                allValues,
                                                selectedValues,
                                                filterText,
                                                onFilterTextChange,
                                                onValueChange,
                                                onReset,
                                                onClose,
                                            }) {
    // Filter & sort alphabetically
    const filteredValues = useMemo(() => {
        let values = !filterText
            ? allValues
            : allValues.filter((val) =>
                val.toLowerCase().includes(filterText.toLowerCase())
            );
        return values.sort((a, b) => a.toLowerCase().localeCompare(b.toLowerCase()));
    }, [allValues, filterText]);

    return (
        <div className="filter-dropdown">
            <button className="filter-reset-button" onClick={onReset}>
                Reset
            </button>
            <input
                type="text"
                placeholder="Search..."
                value={filterText}
                onChange={(e) => onFilterTextChange(e.target.value)}
                className="filter-search-input"
            />
            <div className="filter-values-list">
                {filteredValues.map((val) => {
                    const isChecked = selectedValues.includes(val);
                    return (
                        <label key={val} className="filter-value-item">
                            <input
                                type="checkbox"
                                checked={isChecked}
                                onChange={() => onValueChange(val)}
                            />
                            <span>{val}</span>
                        </label>
                    );
                })}
                {filteredValues.length === 0 && (
                    <div className="no-match-text">No matches</div>
                )}
            </div>
            <button className="filter-close-button" onClick={onClose}>
                Close
            </button>
        </div>
    );
}
